import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UIState {
  modals: {
    addTask: boolean;
    addClient: boolean;
    addUser: boolean;
    comment: boolean;
    estimatedTime: boolean;
    manageColumns: boolean;
    endDay: boolean;
  };
  sidebarCollapsed: boolean;
  quotationPanelOpen: boolean;
  selectedTaskId: number | null;

  // Actions
  toggleModal: (modal: keyof UIState['modals'], open?: boolean) => void;
  toggleSidebar: () => void;
  setQuotationPanel: (open: boolean) => void;
  setSelectedTask: (id: number | null) => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    (set) => ({
      modals: {
        addTask: false,
        addClient: false,
        addUser: false,
        comment: false,
        estimatedTime: false,
        manageColumns: false,
        endDay: false,
      },
      sidebarCollapsed: false,
      quotationPanelOpen: false,
      selectedTaskId: null,

      toggleModal: (modal, open) => {
        set((state) => ({
          modals: {
            ...state.modals,
            [modal]: open !== undefined ? open : !state.modals[modal],
          },
        }));
      },

      toggleSidebar: () => {
        set((state) => ({
          sidebarCollapsed: !state.sidebarCollapsed,
        }));
      },

      setQuotationPanel: (open) => {
        set({ quotationPanelOpen: open });
      },

      setSelectedTask: (id) => {
        set({ selectedTaskId: id });
      },
    }),
    {
      name: 'ui-store',
    }
  )
);